module.exports = __webpack_public_path__ + "media/images/pic/hero/pigs-f737077fe67008672c932c1b95dc16fe.webp";